import axios from 'axios'
import { NODE_BASE_URL } from './serviceHelper'
import { getAxiosOptions } from './serviceHelper'

export const rulesService = {
  validateRule: async (user, rule) => {
    return (await axios.post(`${NODE_BASE_URL}/rule-engine/validate`, rule, getAxiosOptions(user)))
      .data
  },
  createRule: async (user, rule) => {
    return (await axios.post(`${NODE_BASE_URL}/rule-engine`, rule, getAxiosOptions(user))).data
  },
  updateRule: async (user, selectedRuleId, payload) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/rule-engine/${selectedRuleId}`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },
  deleteRule: async (user, selectedRuleId) => {
    return (
      await axios.delete(`${NODE_BASE_URL}/rule-engine/${selectedRuleId}`, getAxiosOptions(user))
    ).data
  },
  getRules: async (user, processTemplateId, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/rule-engine/${processTemplateId}/${activityTemplateId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  getUsersRules: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/rule-engine`, getAxiosOptions(user))).data
  },
  getActivities: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/rule-engine/activities`, getAxiosOptions(user))).data
  },
  getProcessDataVariableKeys: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/rule-engine/process-data-variables/${activityTemplateId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  triggerRule: async (user, ruleId, processId) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/rule-engine/trigger-rule/${ruleId}/${processId}`,
        {},
        getAxiosOptions(user),
      )
    ).data
  },
  formatDSL: async (user, dsl) => {
    return (
      await axios.post(`${NODE_BASE_URL}/rule-engine/format-dsl`, { dsl }, getAxiosOptions(user))
    ).data
  },
  generateDSLofPrompt: async (user, data) => {
    return (
      await axios.post(`${NODE_BASE_URL}/rule-engine/generate-dsl`, data, getAxiosOptions(user))
    ).data
  },
}
